import { apiConnection } from "@/services/api-connection";
import { pictureManager } from "@/services/utilities/picture-manager";
import router from "@/router";
import { platformStore, triadStore } from "@/main";

const URL = "/app/training-course/list";
const URL_ONE = "/app/training-course/";

class TrainingCourseManager {
  MODULE_STUDEA_SKILL = "MODULE_STUDEA_SKILL";
  MODULE_STUDEA_QUESTIONNAIRE = "MODULE_STUDEA_QUESTIONNAIRE";
  MODULE_STUDEA_ABSENCE = "MODULE_STUDEA_ABSENCE";
  MODULE_STUDEA_DOCUMENT = "MODULE_STUDEA_DOCUMENT";
  MODULE_STUDEA_MESSAGE = "MODULE_STUDEA_MESSAGE";
  MODULE_STUDEA_COURSE = "MODULE_STUDEA_COURSE";
  MODULE_STUDEA_NOTE = "MODULE_STUDEA_NOTE";
  MODULE_STUDEA_NOTEPAD = "MODULE_STUDEA_NOTEPAD";
  MODULE_STUDEA_REGISTRATION = "MODULE_STUDEA_REGISTRATION";
  MODULE_STUDEA_WEBLINKS = "MODULE_STUDEA_WEBLINKS";

  loadTrainingCourseList = (params = {}) => {
    params = { ...params, length: 10 };
    return apiConnection.get(URL, params, true).then((response) => response);
  };

  loadTrainingCourse = (id) => {
    return apiConnection.get(URL_ONE + id).then((response) => response);
  };

  getPageDatas(code) {
    const triad = triadStore.triad;
    let menu = null;
    if (triad && triad.menu) {
      menu = Object.values(triad.menu).find((menu) => menu.code === code);
    }
    return menu && menu.title ? menu.title : "";
  }

  getPageHelp(code) {
    const triad = triadStore.triad;
    let menu = null;
    if (triad && triad.menu) {
      menu = Object.values(triad.menu).find((menu) => menu.code === code);
    }
    return menu && menu.helpDocument ? menu.helpDocument : null;
  }

  setPageTitle(code, currentRouter = router) {
    const title = this.getPageDatas(code);
    currentRouter.currentRoute.value.meta.title = title;
    return title;
  }

  setNewCfaLogo(trainingCourse) {
    const itemPicture =
      trainingCourse?.training?.logoTraining || trainingCourse?.training?.institution?.logoInstitution;

    this.updateCfaLogo(itemPicture, "logo");
  }

  updateCfaLogo(itemPicture, prefix) {
    if (!itemPicture) {
      platformStore.setLogoCfaPromotion(null);
      return;
    }

    const urlWithPrefix = pictureManager.setPicture(itemPicture, prefix);
    const urlWithoutPrefix = pictureManager.setPicture(itemPicture);

    const img = new Image();

    img.onload = () => platformStore.setLogoCfaPromotion(urlWithPrefix);
    img.onerror = () => platformStore.setLogoCfaPromotion(urlWithoutPrefix);
    img.src = urlWithPrefix;
  }

  setCurrentTrainingCourseYear(trainingCourse) {
    if (trainingCourse?.currentTrainingCourseYear?.id) {
      return trainingCourse.currentTrainingCourseYear.id;
    } else if (trainingCourse?.trainingCourseYears?.length) {
      return trainingCourse.trainingCourseYears[0]?.id;
    } else {
      return null;
    }
  }
}

export const trainingCourseManager = new TrainingCourseManager();
